export default __webpack_public_path__ + "static/media/instagramlogo.fbda125b.png";